import React, {Suspense, useEffect} from 'react'
import {BrowserRouter, Outlet} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {I18nProvider} from '../_theme/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_theme/layout/core'
import {AppRoutes} from './routing/AppRoutes'
import {AuthInit} from './features/auth/AuthInit'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
            <Outlet />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
